import { CroppingAttr, defineDirective, ICrop, ICropping, ICroppingEditContext, IField, IHolding, isFunction, models } from "../../omnia"
import { IFieldsService } from "../../types"

import m = models

export class CroppingAttrsEditorCtrl {

    static create(): ng.IDirective {

        return defineDirective(CroppingAttrsEditorCtrl, "app/fields/edit/cropping/attributes.html", {
            context: "<",
            readOnly: "<",
            grassSiteClass: "<"
        });

    }


    private _ctxt: ICroppingEditContext
    private _watch: Function

    readOnly: boolean

    genericSelectFields: CroppingAttr[]

    /** Indicates if the grass site class should be displayed */
    grassSiteClass: boolean

    /** Cached value for the grass site class */
    _grassSiteClass: number




    static $inject = ["$scope", "OmniaFieldsService"]

    constructor(private readonly $scope: ng.IScope, private readonly svc: IFieldsService) {
    }

    $onInit() {
        this.setup()
    }

    protected setup() {

        if (this.$scope) {

            if (this._watch) {
                this._watch();
                this._watch = null;
            }

            if (this._ctxt) {

                this._watch = this.$scope.$watchGroup(["vm.context.crop", "vm.context.scotland"], () => {

                    this.genericSelectFields = CroppingAttr.defineAttrs(this._ctxt);

                });

            }

        }

    }

    get context(): ICroppingEditContext {
        return this._ctxt;
    }

    set context(value: ICroppingEditContext) {
        this._ctxt = value;
        this.setup();
    }

    get crop(): ICrop {
        return this._ctxt?.crop;
    }

    get target(): ICropping {
        return this._ctxt?.target;
    }

    get showGrassSiteClass() {
        const { crop, context } = this
        return crop?.Grass && context?.scotland
    }

    getGrassSiteClass() {

        if (this._grassSiteClass === undefined) {
            const { svc: { holding }, context } = this
            const field = context?.target?.Field
            this._grassSiteClass = getGrassSiteClass(holding, field)
        }

        return this._grassSiteClass

    }

    public canBeUndersown(): boolean {

        var c = this._ctxt;

        if (c) {
            return c.scotland && c.crop && c.crop.Undersown;
        }

    }

    checkGenericFieldRequired(field: CroppingAttr): boolean {
        return field && field.isRequired(this.crop, () => this.target)
    }

    getGenericFieldParameters(field: CroppingAttr): any[] {
        return field.getParameters(this._ctxt)
    }

    validate(attr: CroppingAttr, value) {
        return !this.getValidationError(attr, value)
    }

    getValidationError(attr: CroppingAttr, value) {

        value = value || this.target[attr.model]

        const err = attr && isFunction(attr.validate)
            ? attr.validate(this.target, value)
            : undefined

        return err

    }

}

function getGrassSiteClass(holding: IHolding, field: IField) {

    const town = holding.Town
    if (!town) return null

    const shallow = (field.SoilTypeId == m.SoilTypeId.Sand) || (field.SubsoilTypeId == m.SubsoilTypeId.Shallow)

    return (shallow ? town.GrassSiteClassShallow : null) || town.GrassSiteClass

}
